module.exports = __webpack_public_path__ + "static/media/dona_beja.820a8847.png";